// rollover
var preLoadImg = new Object();
 
function initRollOvers(){
  $("img.imgover,input.imgover").each(function(){
    var imgSrc = this.src;
    var sep = imgSrc.lastIndexOf('.');
    var onSrc = imgSrc.substr(0, sep) + '_o' + imgSrc.substr(sep, 4);
    preLoadImg[imgSrc] = new Image();
    preLoadImg[imgSrc].src = onSrc;
    $(this).hover(
      function() { this.src = onSrc; },
      function() { this.src = imgSrc; }
    );
  });
}
$(function(){
  initRollOvers();
});


// smoothScroll
var targetIdHold = jQuery(this.hash);

jQuery.easing.quart = function (x, t, b, c, d) {
  return -c * ((t = t / d - 1) * t * t * t - 1) + b;
};

jQuery(document).ready(function () {
  jQuery('a[href*="#"]').click(function () {
    let targetId = jQuery(this.hash);
    let scroll = $(window).scrollTop();

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      let target = jQuery(this.hash);
      target = target.length && target || jQuery('[name=' + this.hash.slice(1) + ']');
      let headerH = $('#header').innerHeight();

      if (target.length) {
        let targetOffset = target.offset().top - headerH;

        $('html,body').animate({
          scrollTop: targetOffset
        }, 1200, 'swing');

        return false;
      }
    }
  });
});


// 他ページからのsmoothScroll
$(function () {
  let para = location.hash;

  if (para) {
    if ( para == '#top' ) {
      $('body,html').stop().scrollTop(0);
    } else {
       //スクロールするとheaderの高さが変わるので、#top以外へ遷移する場合は1pxスクロールした状態で一旦止める
      $('body,html').stop().scrollTop(1);
    }

    setTimeout(function () {
      let headerH = $('#header').innerHeight();
      let position = $(para).offset().top - headerH;
      $("html, body").animate({
        scrollTop: position
      }, 1200, "swing");
    }, 1000);
  }
});


// slide btn
$(function(){
  $(".js-slideBtn").each(function(index,element) {
    $(element).click(function() {
      $(this).toggleClass('is-active');
      $(element).next(".js-slidePanel").slideToggle(300);
    });
  });

  // ハッシュがあるときはオープン
  if (window.location.hash.length>0) {
    if ($(window.location.hash).next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {
    } else {
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").toggleClass('is-active');
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
    }
  }
});


//ドロワー開閉時間(CSSの設定と同一時間にする)
var drawerDuration = 500; //500 = 0.5s

// ドロワー開閉
$(function () {
  var drawer_flag = $('#drawer').attr('data-drawer');

  $("#drawerOpen").click(function () {
    drawer_flag = $('#drawer').attr('data-drawer');
    $('#drawer').attr('data-drawerprocessing', 'true'); //ドロワー処理中フラグを立てる

    if (drawer_flag == 'init' || drawer_flag == 'close') {
      $('body').attr('data-drawer', 'open');
      $('#drawer').attr('data-drawer', 'open');
      $('#drawerOpen').attr('data-drawer', 'open');
    } else {
      $('body').attr('data-drawer', 'close');
      $('#drawer').attr('data-drawer', 'close');
      $('#drawerOpen').attr('data-drawer', 'close');
    }

    drawerDuration = drawerDuration + 10; //ドロワーが開ききる直前に表示ががたつかないよう、処理時間を0.01s増やす

    setTimeout(function () {
      $('#drawer').attr('data-drawerprocessing', 'false'); //ドロワー処理中フラグを下げる
    }, drawerDuration);
  });
});


//メニュークリック
$(function(){
  $(".js-gnavLink").each(function(index,element) {
    $(element).click(function() {
      if ( $('#drawer').attr('data-drawer') == 'open' ) {
        $('body').attr('data-drawer', 'close');
        $('#drawer').attr('data-drawer', 'close');
        $('#drawerOpen').attr('data-drawer', 'close');
      }
    });
  });
});


//スクロール連動(ヘッダー)
$(window).on('load scroll', function(){
  let header = $('#header');
  let scroll  = $(window).scrollTop();

  if (scroll > 0) {
    if ( header.attr('data-scroll') == 'init' || header.attr('data-scroll') == 'false' ) {
      header.attr('data-scroll', 'true');
    }
  } else {
    if ( header.attr('data-scroll') == 'init' || header.attr('data-scroll') == 'true' ) {
      header.attr('data-scroll', 'false');
    }
  }
});


//スクロール・リサイズ連動
$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW   = window.innerWidth;        //スクロールバーを含む幅 
  let winH    = $(window).height();  //ウィンドウの高さ
  let scroll  = $(window).scrollTop();
  let fadeUpItem  = $('.js-fadeUpItem');

  //要素フェードアップ
  fadeUpItem.each(function(){
    let fuiTop = $(this).offset().top;

    // 要素が画面の上から75%(下から25%)に来た時に動く
    let fadeUpItemPos = fuiTop - (winH * 0.75);

    if (scroll > fadeUpItemPos) {
      if ( $(this).attr('data-move') == 'false' ) {
        $(this).attr('data-move', 'true');
      }

    }
  });
});


// 電話番号リンク
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(function() {
    $('.js-tellink').each(function() {
      var str = $(this).html();

      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      }
    });
  });
}
